import React, { useState, useEffect } from 'react';
import { useReactiveVar } from '@apollo/client';
import { lastAccessedOrganizationVar } from '../../../cache';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, LinearProgress, TextField, } from '@material-ui/core';
import { useCreateEtl } from '../../../hooks';
import Lottie from '../Lottie';
import checkmark from '../../../animations/checkmark.json';
import errormark from '../../../animations/errormark.json';
var EtlRegister = function (_a) {
    var datasourceId = _a.datasourceId, query = _a.query, setDestination = _a.setDestination;
    var currentOrg = useReactiveVar(lastAccessedOrganizationVar);
    var _b = useState(false), open = _b[0], setOpen = _b[1];
    var _c = useState(false), finishAnimation = _c[0], setFinishAnimation = _c[1];
    var _d = useState(), etlName = _d[0], setEtlName = _d[1];
    var _e = useState(), destinationName = _e[0], setDestinationName = _e[1];
    var _f = useCreateEtl(datasourceId, currentOrg.id), data = _f.data, createEtl = _f.createEtl, processing = _f.processing;
    useEffect(function () {
        data && setDestination(data.createEtl.destination);
    }, [data]);
    useEffect(function () {
        if (open && !processing)
            setFinishAnimation(true);
    }, [processing]);
    var handleEtlName = function (event) {
        setEtlName(event.target.value);
    };
    var handleDestinationName = function (event) {
        setDestinationName(event.target.value);
    };
    var handleClickOpen = function () {
        setOpen(true);
    };
    var handleClose = function () {
        setOpen(false);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { variant: "contained", color: "primary", onClick: handleClickOpen }, "Register this as Datamart"),
        React.createElement(Dialog, { open: open, onClose: handleClose, "aria-labelledby": "form-dialog-title" },
            React.createElement(DialogTitle, { id: "form-dialog-title" }, "Datamart"),
            React.createElement(DialogContent, null,
                React.createElement(DialogContentText, null, "\u8AAC\u660E\u6587"),
                React.createElement(TextField, { value: etlName, label: "Etl Name", placeholder: "Daily Report", onChange: handleEtlName }),
                React.createElement(TextField, { value: destinationName, label: "Destination Name", placeholder: "My Report Table", onChange: handleDestinationName })),
            React.createElement(DialogActions, null,
                finishAnimation && (React.createElement(Lottie, { data: data ? checkmark : errormark, width: 36, height: 36, onEnd: function () {
                        setOpen(false);
                        setFinishAnimation(false);
                    } })),
                React.createElement(Button, { variant: "contained", color: "secondary", disabled: !query, 
                    //@ts-ignore
                    onClick: function () { return createEtl(query, etlName, destinationName); } }, "Submit")),
            processing && React.createElement(LinearProgress, null))));
};
export default EtlRegister;
